import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState } from 'react';
import i18n from '../i18n.js';
const defaultLocale = i18n.language ? i18n.language.split('-')[0] : 'en';
export const LocaleContext = createContext({
    locale: defaultLocale,
    setLocale: () => { },
});
export const LocaleProvider = ({ children }) => {
    const [locale, setLocaleState] = useState(defaultLocale);
    React.useEffect(() => {
        const currentLang = i18n.language ? i18n.language.split('-')[0] : 'en';
        setLocaleState(currentLang);
    }, []);
    const setLocale = (newLocale) => {
        setLocaleState(newLocale);
        i18n.changeLanguage(newLocale);
    };
    const value = { locale, setLocale };
    return (_jsx(LocaleContext.Provider, { value: value, children: children }));
};
